import { Currency, InclusionLawEnum, ValidUntil } from '../../store/config/enums';
import { currencyHelper } from '../../helpers/currencyHelper';
import { dateHelper } from '../../helpers/dateHelper';
import { inclusionLawHelper } from '../../helpers/inclusionLawHelper';

const options = {
  currency: [
    {
      id: Currency.PESO,
      value: `${currencyHelper.getCurrencyName(Currency.PESO)}`,
    },
    {
      id: Currency.DOLAR,
      value: `${currencyHelper.getCurrencyName(Currency.DOLAR)}`,
    },
  ],
  vatRate: [
    {
      id: 0,
      value: '0%',
    },
    {
      id: 10,
      value: '10%',
    },
    {
      id: 22,
      value: '22%',
    },
  ],
  vatRateFor17934: [
    {
      id: 10,
      value: '10%',
    },
    {
      id: 22,
      value: '22%',
    },
  ],
  validUntil: [
    {
      id: ValidUntil.NONE,
      value: dateHelper.getValidUntilName(ValidUntil.NONE),
    },
    {
      id: ValidUntil.HALFHOUR,
      value: dateHelper.getValidUntilName(ValidUntil.HALFHOUR),
    },
    {
      id: ValidUntil.ONEHOUR,
      value: dateHelper.getValidUntilName(ValidUntil.ONEHOUR),
    },
    {
      id: ValidUntil.TWOHOURS,
      value: dateHelper.getValidUntilName(ValidUntil.TWOHOURS),
    },
    {
      id: ValidUntil.DAYEND,
      value: dateHelper.getValidUntilName(ValidUntil.DAYEND),
    },
    {
      id: ValidUntil.MONTHEND,
      value: dateHelper.getValidUntilName(ValidUntil.MONTHEND),
    },
    {
      id: ValidUntil.CUSTOM,
      value: dateHelper.getValidUntilName(ValidUntil.CUSTOM),
    },
  ],
  inclusionLaw: [
    {
      id: 0,
      value: inclusionLawHelper.getInclusionLawName(InclusionLawEnum.NONE),
    },
    {
      id: 1,
      value: inclusionLawHelper.getInclusionLawName(InclusionLawEnum.LAW17934),
    },
    {
      id: 6,
      value: inclusionLawHelper.getInclusionLawName(InclusionLawEnum.LAW19210),
    },
  ],
};

export default options;
